import * as React from "react";
import {Box, Inline, Text} from "@unibuddy/patron";
import styled from "styled-components";

import {getenv} from "../../../../../util/getEnv";
import useUniversityColor from "../../../UniversityProvider/hooks/useUniversityColor";
import {useUniversity} from "../../../UniversityProvider/UniversityProvider";
import {UnibuddyLogoSvg} from "../../../../../components/UnibuddyLogoSvg/UnibuddyLogoSvg";

const StyledLink = styled.a`
    &:hover {
        text-decoration: none;
        background-color: #f7f8f9 !important;
    }
    text-decoration: none !important;
`;

const StyledText = styled(Text)`
    letter-spacing: 2px;
`;

const MessageIndicator: React.FC = () => {
    const universityColor = useUniversityColor();

    return (
        <Box
            minW="20px"
            minH="20px"
            display="flex"
            justifyContent="center"
            alignItems="center"
            borderRadius="medium"
            bgColor={universityColor}
        >
            <Text size="small" color="white">
                1
            </Text>
        </Box>
    );
};

export const AssistantInboxItem: React.FC = () => {
    const {id} = useUniversity();
    const assistantUrl = getenv(
        "STANDALONE_ASSISTANT_URL",
        "https://prospect-guidance-ui.unibuddy.co",
    );

    return (
        <StyledLink
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            href={`${assistantUrl}/?render=chat&universityId=${id}`}
            target="_blank"
            rel="noreferrer noopener"
        >
            <Box
                padding="small"
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                _hover={{bgColor: "#f7f8f9"}}
            >
                <Box display="flex" alignItems="center">
                    <Box
                        minW="40px"
                        minH="40px"
                        maxW="40px"
                        maxH="40px"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        bgColor="#131622"
                        borderRadius="full"
                        alt="Unibuddy Assistant logo"
                    >
                        <UnibuddyLogoSvg color="white" width="22px" height="20px" />
                    </Box>
                    <Box display="flex" flexDirection="column" paddingLeft="small">
                        <Box paddingBottom="small">
                            <Inline verticalAlign="center" space="xsmall">
                                <Text size="medium" weight="bold">
                                    Assistant
                                </Text>
                                <Box
                                    borderRadius="xxsmall"
                                    bgColor="#CDE4FE"
                                    padding="xsmall"
                                    paddingY="xxsmall"
                                >
                                    <StyledText size="small" weight="bold" color="#013E83">
                                        BETA
                                    </StyledText>
                                </Box>
                            </Inline>
                        </Box>
                        <Box w="100%">
                            <Text size="small" color="#757474" truncate>
                                {
                                    "Hello there 👋, I’m your assistant. I'm here to answer your questions, and connect you with a current student or faculty member."
                                }
                            </Text>
                        </Box>
                    </Box>
                </Box>
                <MessageIndicator />
            </Box>
        </StyledLink>
    );
};
